import types from "../../actions/types"

export default function update(state, action) {
  switch (action.type) {
    case types.update:
      return state
    case types.updateSuccess:
      return {
        ...state,
        data: action.data,
        error: null,
      }
    case types.updateError:
      return {
        ...state,
        error: action.error,
      }
    case types.updateCancel:
      return state
    default:
      return state
  }
}
